const listenToCart = callback => {
  const ShopifyCartURLs = [
    'add',
    'add.js',
    'change',
    'change.js',
    'clear',
    'clear.js',
    'update',
    'update.js'
  ];

  function isShopifyCartURL(url) { if (!url) return false;
    // coerce Request/URL objects to a string before .split()
    var href = typeof url === 'string' ? url : (typeof url.url === 'string' ? url.url : (typeof url.href === 'string' ? url.href : (url.toString ? url.toString() : ''))); if (typeof href !== 'string' || !href) return false; const path = href.split('/').pop().split('?')[0]; return ShopifyCartURLs.includes(path);
  }

  function dispatchEvent(url, detail) {
    // check if detail is an object or json string
    if (typeof detail === 'string') {
      try {
        detail = JSON.parse(detail);
      } catch (error) {
        console.error('listenToCart dispatchEvent error :', error);
      }
    }
    callback(detail);
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== 'function') return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);
      if (isShopifyCartURL(arguments[0])) {
        response.then(res => {
          res
            .clone()
            .json()
            .then(data => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener('load', function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  XHROverride();
  fetchOverride();
};

document.addEventListener('DOMContentLoaded', function () {
  setInterval(() => {
    let mobileMenu = document.querySelector('.header-sidebar');
    let announcementBar = document.querySelector('.shopify-section--announcement-bar');
    if (announcementBar) {
      let inScreen =
        announcementBar.getBoundingClientRect().top < window.innerHeight &&
        announcementBar.getBoundingClientRect().bottom > 0;
      if (inScreen) {
        document.body.style.setProperty('--mobile-top', `${announcementBar.offsetHeight}px`);
      } else {
        document.body.style.setProperty('--mobile-top', `0px`);
      }
    }
  }, 400);

  let cartCount = document.querySelector('.header__cart-count');
  const updateCartCount = async () => {
    let cart = await fetch('/cart.js');
    cart = await cart.json();

    // Paid items only: the free cleanser (Rebuy gift with purchase) doesn't count.
    const paidCount = cart.items.reduce((total, item) => {
      const attribution = (item.properties && item.properties._attribution) || '';
      return total + (/gift with purchase/i.test(attribution) ? 0 : item.quantity);
    }, 0);
    cartCount.querySelector('span').innerHTML = paidCount;
    if (paidCount > 0) {
      cartCount.classList.add('header__cart-count--active');
    } else {
      cartCount.classList.remove('header__cart-count--active');
    }
  };

  listenToCart(updateCartCount);
  updateCartCount();

  setTimeout(() => {
    let ingredientsToggleButton = document.querySelector('.close-popup');
    let ingredientsPopup = document.querySelector('.ingredients-popup');
    let ingredientsPopupLink = document.querySelector('.formlink.button--link');

    document.addEventListener('click', e => {
      if (!!e.target.closest('.formlink.button--link')) {
        ingredientsPopup.classList.add('ingredients-popup--active');
        document.documentElement.style.overflow = 'hidden';
      }
    });

    if (ingredientsToggleButton) {
      ingredientsToggleButton.addEventListener('click', e => {
        ingredientsPopup.classList.toggle('ingredients-popup--active');
        document.documentElement.style.overflow = ingredientsPopup.classList.contains(
          'ingredients-popup--active'
        )
          ? 'hidden'
          : 'auto';
      });
    }
  }, 200);

  let accordionToggles = document.querySelectorAll('.accordion__toggle');
  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      let accordionToggle = e.target.closest('.accordion__disclosure');
      if (accordionToggle.getAttribute('aria-expanded') === 'false') {
        accordionToggles.forEach(toggle => {
          if (toggle.closest('.accordion__disclosure').getAttribute('aria-expanded') === 'true') {
            toggle.click();
          }
        });
      }
    });
  });

  let carousel = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carousel) {
    let pageIndicator = document.querySelector('.product-gallery__count');
    carousel.addEventListener('carousel:change', function (event) {
      pageIndicator.innerHTML = `${event.detail.index + 1}/${pageIndicator.dataset.max}`;
    });
  }

  let productSticky = document.querySelector('.product-sticky__atc');
  let productGallery = document.querySelector('.product-gallery__image-list');
  let productInfo = document.querySelector('.product-info__block-list');
  let infoProductSection = document.querySelector('.product-info');

  if (productSticky) {
    document.addEventListener('variant:change', function (event) {
      let originalATC = infoProductSection.querySelector(
        '.product-info__block-list .product-info__block-item[data-block-id="buy_buttons"] button[type="submit"]'
      );
      let originalVariant = infoProductSection.querySelector(
        '.product-info__block-list .product-info__block-item[data-block-id="buy_buttons"] input[name="id"]'
      );
      if (originalATC) {
        productSticky.querySelector('.buy-buttons button').innerHTML = originalATC.innerHTML;
        productSticky.querySelector('.buy-buttons button').disabled = originalATC.disabled;
        productSticky.querySelector('product-form input[name="id"]').value = originalVariant.value;
      }
    });

    const updateProductSticky = () => {
      let productBuyButtons = productInfo?.querySelector('.buy-buttons');

      // let productGalleryTop = productGallery.getBoundingClientRect().top;
      let productBuyButtonsBottom = productBuyButtons.getBoundingClientRect().bottom;

      if (productBuyButtonsBottom < 0) {
        productSticky.classList.add('product-sticky__atc--active');
      } else {
        productSticky.classList.remove('product-sticky__atc--active');
      }
    };
    updateProductSticky();

    window.addEventListener('scroll', updateProductSticky);
  }

  // let blockSwatchesSecond = document.querySelector('.variant-picker__option-values input:nth-of-type(2)');
  // if (!!blockSwatchesSecond && window.location.href.indexOf('variant=') === -1) {
  //   blockSwatchesSecond.click();
  // }

  // Product variant handling
  const handleVariantChange = () => {
    const variantOptions = document.querySelectorAll('.variant-option');

    variantOptions.forEach(option => {
      option.addEventListener('click', function () {
        const radioInput = this.querySelector('input[type="radio"]');
        const variantId = this.dataset.variantId;
        const price = radioInput.dataset.price;
        const comparePrice = radioInput.dataset.comparePrice;

        // Update selected state
        variantOptions.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');

        // Check the radio button
        radioInput.checked = true;

        // Update all product form hidden inputs
        const productForms = document.querySelectorAll('product-form');
        productForms.forEach(form => {
          const hiddenIdInput = form.querySelector('input[name="id"]');
          if (hiddenIdInput) {
            hiddenIdInput.value = variantId;
          }
        });

        // Update add to cart button text and price
        const updateButtonPrices = container => {
          // Update sale prices in price lists
          const salePriceElements = container.querySelectorAll('sale-price');
          salePriceElements.forEach(el => {
            // Find the price text node (skip the screen reader text)
            const srSpan = el.querySelector('.sr-only');
            if (srSpan) {
              // Replace everything after the sr-only span
              const textNode = Array.from(el.childNodes).find(
                node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
              );
              if (textNode) {
                textNode.textContent = price;
              } else {
                // If no text node, create one
                el.appendChild(document.createTextNode(price));
              }
            } else {
              // If no sr-only span, replace all text content
              el.textContent = price;
            }
          });

          // Update compare-at prices if they exist
          if (comparePrice && comparePrice !== price) {
            const compareAtPriceElements = container.querySelectorAll('compare-at-price');
            compareAtPriceElements.forEach(el => {
              const srSpan = el.querySelector('.sr-only');
              if (srSpan) {
                const textNode = Array.from(el.childNodes).find(
                  node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
                );
                if (textNode) {
                  textNode.textContent = comparePrice;
                } else {
                  el.appendChild(document.createTextNode(comparePrice));
                }
              } else {
                el.textContent = comparePrice;
              }
            });
          }

          // Update button text that includes price (e.g., "Add to Cart | $29.99")
          const submitButtons = container.querySelectorAll('button[type="submit"]');
          submitButtons.forEach(button => {
            const currentText = button.textContent;
            if (currentText.includes('|')) {
              // Replace the price part after the pipe
              const beforePipe = currentText.split('|')[0].trim();
              button.textContent = `${beforePipe} | ${price}`;
            }
          });

          // Also update any generic price/money elements for backwards compatibility
          const priceElements = container.querySelectorAll('.price, .money');
          priceElements.forEach(el => {
            el.textContent = price;
          });
        };

        // Update main product form prices
        const productInfo = document.querySelector('.product-info');
        if (productInfo) {
          updateButtonPrices(productInfo);
        }

        // Update sticky add to cart prices
        const productSticky = document.querySelector('.product-sticky__atc');
        if (productSticky) {
          updateButtonPrices(productSticky);
        }

        // Dispatch variant change event
        document.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: {
              variant: {
                id: variantId,
                price: price,
                compare_at_price: comparePrice
              }
            }
          })
        );
      });
    });
  };

  // Initialize variant handling after DOM is ready
  setTimeout(handleVariantChange, 100);

  const widgetEventHandler = event => {
    let widget = event.detail.widget;
    let widgetId = widget.id;
    if (widgetId != '194973' && widgetId != '191848') {
      return;
    }
    let products = event.detail.products || widget.data.products;
    if (!products || products.length === 0) {
      return;
    }
    products.map(product => {
      let productElement = document.querySelector(
        `div[data-rebuy-component] div[data-rebuy-id="${widgetId}"] .product-id-${product.id} .rebuy-product-info`
      );
      let existingMetafield = productElement.querySelector('.rebuy-product-description__metafield');
      if (productElement && !existingMetafield) {
        let productMetafield = product.metafields.custom.product_card;
        if (productMetafield) {
          let metafieldElement = document.createElement('div');
          metafieldElement.classList.add('rebuy-product-description__metafield');
          metafieldElement.innerHTML = productMetafield;

          productElement.insertBefore(
            metafieldElement,
            productElement.querySelector('.rebuy-product-price')
          );
        }
      }
    });
  };
  document.addEventListener('rebuy.productsChange', event => {
    setTimeout(() => {
      widgetEventHandler(event);
    });
  });
  document.addEventListener('rebuy.ready', widgetEventHandler);
});

const handleProductCardTitles = () => {
  let productCards = document.querySelectorAll('.product-card');
  let cardHeight;
  productCards.forEach((card, i) => {
    let cardsSameEl = card.parentElement.querySelectorAll('.product-card');
    let cardsSameRow = [];
    cardsSameEl.forEach(el => {
      if (card.offsetTop === el.offsetTop) {
        cardsSameRow.push(el);
      }
    });

    cardHeight = Math.max(
      ...cardsSameRow.map(el => el.querySelector('.product-title.product-card__title').offsetHeight)
    );
    cardsSameRow.forEach(el => {
      if (cardHeight !== 0) {
        el.querySelector('.product-title.product-card__title').style.setProperty(
          'height',
          `${cardHeight}px`
        );
      }
    });
  });
};
handleProductCardTitles();
window.addEventListener('resize', handleProductCardTitles);

// Video Carousel Component using Swiper
function initVideoCarousel() {
  const videoCarousels = document.querySelectorAll('.video-carousel .swiper');

  videoCarousels.forEach(carousel => {
    const swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      loop: true,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: false
      },
      on: {
        init: function () {
          this.el.style.width = '100%';
        },
        resize: function () {
          this.update();
        }
      },
      breakpoints: {
        320: { spaceBetween: 12 },
        768: { spaceBetween: 16 }
      }
    });

    // Load mute state from localStorage (default = true)
    let globalMuted = localStorage.getItem('videoCarouselMuted') === 'false' ? false : true;

    // Slides setup
    const slides = carousel.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      const video = slide.querySelector('video');
      const previewContainer = slide.querySelector('.video-carousel__preview-container');
      const videoContainer = slide.querySelector('.video-carousel__video-container');

      if (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;

        // after playback starts, apply saved mute state
        video.addEventListener('play', () => {
          video.muted = globalMuted;
        });
      }

      if (previewContainer) {
        previewContainer.addEventListener('click', () => {
          if (!video || !videoContainer) return;

          // Hide preview, show video
          previewContainer.style.display = 'none';
          video.style.display = 'block';
          videoContainer.style.display = 'block';

          // Pause all other videos
          pauseOtherVideos(carousel, videoContainer);

          // Play this video
          video.currentTime = 0;
          video
            .play()
            .then(() => {
              video.muted = globalMuted; // adjust mute after play kicks in
            })
            .catch(e => console.log('Video play failed:', e));

          togglePlayPauseIcons(videoContainer, true);
          // handlePreviewClick(slide, carousel);
        });
      }

      if (videoContainer) {
        videoContainer.addEventListener('click', e => {
          if (e.target.closest('.video-carousel__mute-control')) return; // let mute handle separately

          if (!video || !videoContainer) return;
          if (video.paused) {
            pauseOtherVideos(carousel, videoContainer);
            video
              .play()
              .then(() => {
                video.muted = globalMuted; // adjust mute after play kicks in
              })
              .catch(e => console.log('Video play failed:', e));
            togglePlayPauseIcons(videoContainer, true);
          } else {
            video.pause();
            togglePlayPauseIcons(videoContainer, false);
          }
          // handlePlayPauseToggle(slide, carousel);
        });
      }
    });

    // Apply initial mute/unmute icon state
    updateMuteIcons(carousel, globalMuted);

    // Global mute/unmute toggle
    carousel.addEventListener('click', function (e) {
      const muteButton = e.target.closest('.video-carousel__mute-control');
      if (!muteButton) return;

      e.stopPropagation();
      globalMuted = !globalMuted;

      // Save state
      localStorage.setItem('videoCarouselMuted', globalMuted);

      // Apply mute state to all currently playing videos
      const allVideos = carousel.querySelectorAll('video');
      allVideos.forEach(v => {
        if (!v.paused) {
          v.muted = globalMuted;
        }
      });

      // Update all mute icons
      updateMuteIcons(carousel, globalMuted);
    });
  });

  function pauseOtherVideos(carousel, currentContainer) {
    const allVideoContainers = carousel.querySelectorAll('.video-carousel__video-container');
    allVideoContainers.forEach(container => {
      if (container === currentContainer) return;
      const v = container.querySelector('video');
      if (v) v.pause();
      togglePlayPauseIcons(container, false);
    });
  }

  function togglePlayPauseIcons(container, isPlaying) {
    const playIcon = container.querySelector('.video-carousel__play-icon');
    const pauseIcon = container.querySelector('.video-carousel__pause-icon');
    if (!playIcon || !pauseIcon) return;

    if (isPlaying) {
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
    } else {
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
    }
  }

  function updateMuteIcons(carousel, isMuted) {
    const allMuteButtons = carousel.querySelectorAll('.video-carousel__mute-control');
    allMuteButtons.forEach(button => {
      const mutedIcon = button.querySelector('.video-carousel__muted-icon');
      const unmutedIcon = button.querySelector('.video-carousel__unmuted-icon');

      if (!mutedIcon || !unmutedIcon) return;

      if (isMuted) {
        mutedIcon.style.display = 'block';
        unmutedIcon.style.display = 'none';
      } else {
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = 'block';
      }
    });
  }
}

// Initialize video carousel when Swiper is ready
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    initVideoCarousel();
  } else {
    const checkSwiper = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiper);
        initVideoCarousel();
      }
    }, 100);
  }
});
